import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { MdArrowForwardIos } from "react-icons/md";

import classes from './Sidebar.module.scss';

import Logo from '../../../assets/logo.svg'
import Backdrop from '../../UI/Backdrop/Backdrop';
import { SidebarNavigationItems } from '../Menus';
import {highlightBugReportButton, unhighlightBugReportButton} from "../../BugReport/BugReportButton/BugRepportButtonUtil";

const Sidebar = (props) => {
    const [sidebarAttachedClasses, setAttachedClasses] = useState([classes.closedContainer])
    const [toggleState, setToggleState] = useState(false)
    const [sidebarState, setSidebarState] = useState(false)

    useEffect(() => {
        if (window.innerWidth <= 500 && props.mobileSidebarState) {
            setToggleState(true)
            setSidebarState(true)
        }

        if (sidebarState || toggleState) {
            setAttachedClasses([classes.openedContainer])
            document.body.style.width = 'calc(100% - 6px)'
            document.body.style.overflow = 'hidden'
            highlightBugReportButton()
        } else {
            setAttachedClasses([classes.closedContainer])
            document.body.style.width = ""
            document.body.style.overflow = ""
            unhighlightBugReportButton()
        }
    }, [sidebarState, toggleState, props.mobileSidebarState])

    const manageSidebarState = () => {
        if (props.mobileSidebarState) {
            setToggleState(false);
            setSidebarState(false);
            props.mobileToggleClicked()
        } else {
            setToggleState(!toggleState);
            setSidebarState(!setSidebarState)
        }
    }

    const closeSidebar = () => {
        setToggleState(false);
        setSidebarState(false)
        if (props.mobileSidebarState) props.mobileToggleClicked()
    }

    const onMouseEnterSidebarHandler = () => {
        if (!toggleState) setSidebarState(true)
    }


    const onMouseLeaveSidebarHandler = () => {
        if (!toggleState) setSidebarState(false)
    }

    const setNavigationItemsJSX = () => SidebarNavigationItems.map((el) =>
        <NavLink exact key={el.path} to={el.path} activeClassName={classes.selectedNavigationItem} onClick={() => closeSidebar()}>
            <div className={`${classes.navigationItemIcon} Sidebar_iconContainer_color`}>{el.icon}</div>
            <div className={`${classes.navigationItemText} Sidebar_text_color`}>{el.text}</div>
        </NavLink>
    );

    return (
        <div>
            <Backdrop show={sidebarState || toggleState} clicked={() => closeSidebar()} />
            <div className={`${sidebarAttachedClasses.join(' ')} Sidebar_container_color`}
                onMouseEnter={onMouseEnterSidebarHandler}
                onMouseLeave={onMouseLeaveSidebarHandler}
            >
                <div className={`${classes.logoContainer} Sidebar_iconContainer_color`}
                    style={{ boxShadow: (localStorage.getItem("theme") && JSON.parse(localStorage.getItem("theme")) === 'dark' && !sidebarState && !toggleState) ? '5px 0 5px #13181c' : 'none' }}>
                    <NavLink to="/" onClick={() => closeSidebar()}>
                        <img src={Logo} alt="Логотип" width="50px" height="50px" className={classes.logo} />
                        <span className={`${classes.navigationItemText} Sidebar_text_color`}>ИИС «БГУИР: Университет»</span>
                    </NavLink>
                </div>
                <div className={`${classes.navigationItemsContainer} Sidebar_navigationItemsContainer_color`}>
                    {setNavigationItemsJSX()}
                    <div className={`${classes.toggleContainer} Sidebar_iconContainer_color`}>
                        <button className={classes.toggle} onClick={() => manageSidebarState()} aria-label="toggle sidebar">
                            <MdArrowForwardIos 
                            style={{ transition: 'all 0.50s' }} 
                            className={`Sidebar_text_color ${toggleState ? classes.toggleArrow : ''}`} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Sidebar;